import {Component, inject} from '@angular/core';
import {DialogRef} from '@angular/cdk/dialog';
import {UiEpgButtonDirective} from '@epg-apps/ui-button';

@Component({
  selector: 'cdh-cdh-download-complete-dialog',
  imports: [UiEpgButtonDirective],
  templateUrl: './cdh-download-complete-dialog.component.html',
  styleUrl: './cdh-download-complete-dialog.component.scss',
})
export class CdhDownloadCompleteDialogComponent {
  private readonly dialogRef = inject(DialogRef);

  close() {
    this.dialogRef.close();
  }
}
